import type { LucideIcon } from "lucide-react"
import {
  AlertCircle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowDownRight,
  ArrowUp,
  ArrowUpRight,
  Building2,
  Calendar,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  Circle,
  Clapperboard,
  Clock,
  Columns3,
  Copy,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileText,
  Filter,
  Flag,
  Folder,
  FoldVertical,
  GripVertical,
  History,
  Image as ImageIcon,
  LayoutGrid,
  Rows2,
  Rows3,
  Rows4,
  Home,
  Info,
  Lightbulb,
  Link,
  Loader2,
  Maximize2,
  Minimize2,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  Menu,
  Minus,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Package,
  PanelRightClose,
  PanelRightOpen,
  Pause,
  Pencil,
  Pin,
  PinOff,
  Phone,
  Play,
  Plus,
  RefreshCw,
  RotateCcw,
  Search,
  Settings,
  Share,
  Shield,
  SlidersHorizontal,
  SmilePlus,
  Sparkles,
  Star,
  Sun,
  Target,
  Terminal,
  Trash2,
  UnfoldVertical,
  Upload,
  User,
  Users,
  Volume2,
  Wrench,
  X,
  XCircle,
  Square,
} from "lucide-react"

/**
 * Curated Lucide icons exposed by name for {@link Icon} and string props (`iconStart`, etc.).
 * Add new entries here when the product needs additional glyphs.
 */
export const iconRegistry = {
  "alert-circle": AlertCircle,
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-down-right": ArrowDownRight,
  "arrow-up": ArrowUp,
  "arrow-up-right": ArrowUpRight,
  "building-2": Building2,
  calendar: Calendar,
  check: Check,
  "check-circle": CheckCircle2,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  "chevrons-up-down": ChevronsUpDown,
  circle: Circle,
  clapperboard: Clapperboard,
  clock: Clock,
  columns: Columns3,
  copy: Copy,
  download: Download,
  "external-link": ExternalLink,
  eye: Eye,
  "eye-off": EyeOff,
  file: File,
  "file-text": FileText,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  "fold-vertical": FoldVertical,
  "unfold-vertical": UnfoldVertical,
  "grip-vertical": GripVertical,
  history: History,
  image: ImageIcon,
  "layout-grid": LayoutGrid,
  "rows-2": Rows2,
  "rows-3": Rows3,
  "rows-4": Rows4,
  home: Home,
  info: Info,
  lightbulb: Lightbulb,
  link: Link,
  loader: Loader2,
  "maximize-2": Maximize2,
  "minimize-2": Minimize2,
  lock: Lock,
  "log-out": LogOut,
  mail: Mail,
  "message-circle": MessageCircle,
  menu: Menu,
  minus: Minus,
  moon: Moon,
  "more-horizontal": MoreHorizontal,
  "more-vertical": MoreVertical,
  package: Package,
  "panel-right-close": PanelRightClose,
  "panel-right-open": PanelRightOpen,
  pause: Pause,
  pencil: Pencil,
  phone: Phone,
  pin: Pin,
  "pin-off": PinOff,
  play: Play,
  plus: Plus,
  "refresh-cw": RefreshCw,
  "rotate-ccw": RotateCcw,
  search: Search,
  settings: Settings,
  share: Share,
  shield: Shield,
  "sliders-horizontal": SlidersHorizontal,
  "smile-plus": SmilePlus,
  sparkles: Sparkles,
  square: Square,
  star: Star,
  sun: Sun,
  target: Target,
  terminal: Terminal,
  "trash-2": Trash2,
  upload: Upload,
  user: User,
  users: Users,
  "volume-2": Volume2,
  wrench: Wrench,
  x: X,
  "x-circle": XCircle,
} as const satisfies Record<string, LucideIcon>

export type IconName = keyof typeof iconRegistry

export const ICON_NAMES = Object.keys(iconRegistry) as IconName[]

export function getIconComponent(name: IconName): LucideIcon | undefined {
  return iconRegistry[name]
}
